import React from "react";
import {NextPage} from "next";
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import WaveLayout from "../src/layouts/WaweLayout";
import ForgotPasswordPageComp from "../src/components/forgotPasswordPage/ForgotPasswordPageComp";

const ForgotPassword: NextPage = () => {
    return (
        <React.Fragment>
            <HtmlHead pageTitle="Şifremi Unuttum | Pembe Panjur"
                        description="Pembe Panjur şifremi unuttum sayfası ile ilgili detaylara sayfamızdan ulaşabilirsiniz."
                        canonical={false}
            />
            <WaveLayout bodyBackgroundColor={true} backgroundColor={'rgba(0, 0, 0, 0.04);'} hamburgerMenuType={'black'}
                        loginButtonText={true} loginButtonMenu={true}>
                <ForgotPasswordPageComp/>
            </WaveLayout>
        </React.Fragment>
    );
}

export default ForgotPassword;
